import React from 'react';
import { useContext } from 'react';
import modalContext from '../../context/modal/modalContext';
import Button from '../../components/Button';
import CustomModal from '../../components/CustomModal';
import InfoPopUp from '../../components/InfoPopUp';
import { SupportedChains, WithdrawlTypes } from '../../config/constants';
import CustomModalHeader from '../../components/CustomModal/CustomModalHeader';
import { useWeb3React } from '@web3-react/core';

const WithdrawalMethod: React.FC = () => {
    const { setModalData, openModal, closeModal } = useContext(modalContext);

    const { chainId } = useWeb3React();

    const onClose = () => closeModal('withdrawalMethod');

    const withdrawal = (type: string) => {
        setModalData((prev) => ({ ...prev, type }));
        onClose();
        openModal('spoolWithdraw');
    };

    return (
        <CustomModal modalName='withdrawalMethod' className='withdrawal-method'>
            <CustomModalHeader
                title={
                    <>
                        Select your Withdrawal Method{' '}
                        <InfoPopUp>
                            Once a week, Spool will undergo a 1 minute maintenance period
                            under which withdrawals will be temporarily suspended. If you
                            experience an issue where you are unable to withdraw, this is
                            likely the cause, and the solution is to try again after 1
                            minute has elapsed.
                        </InfoPopUp>
                    </>
                }
                onClose={onClose}
            />
            <div className='options-container'>
                <div>
                    <div className='title'>Slow but Cheap</div>
                    <p>
                        Your withdrawal will be made “Pending”, and will become “Ready to
                        Claim” the next time Do Hard Work is executed.
                        <br />
                        (Generally within $
                        {chainId === SupportedChains.ARBITRUM_ONE ? '24 hours' : '3 days'}
                        )
                    </p>
                </div>
                <div>
                    <div className='title'>Fast but Expensive</div>
                    <p>
                        Withdraw immediately, at a higher cost. Your actual withdrawal may
                        vary due to slippage, fees, and much higher gas costs.
                        <br />
                        (May require multiple transactions)
                    </p>
                </div>
                <Button onClick={() => withdrawal(WithdrawlTypes.SLOW)}>
                    Withdraw Slow
                </Button>
                <Button onClick={() => withdrawal(WithdrawlTypes.FAST)}>
                    Withdraw Fast
                </Button>
            </div>
        </CustomModal>
    );
};

export default WithdrawalMethod;
